import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const EmployeeBlockedRoute = ({ children }) => {
    const { userRole } = useAuth();

    if (userRole === 'Employee') {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default EmployeeBlockedRoute;
